export default class Behav {
    constructor() {
        this.behaviors = {};
    }

    add(behavior, topic = 'load', args = []) {
        if (!this.behaviors[topic]) {
            this.behaviors[topic] = [];
        }
        this.behaviors[topic].push({ behavior, args });
    }

    apply(selector, topic = 'load') {
        const elements = $(selector);
        
        if (this.behaviors[topic]) {
            this.behaviors[topic].forEach(({ behavior, args }) => {
                // On repasse à l'appel original (tous les éléments d'un coup)
                // pour ne pas casser vos fonctions existantes
                behavior(elements, ...args);
            });
        }
    }
}
